'use client'

import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from "@/app/components/ui/tooltip";
import { InfoCircledIcon } from '@radix-ui/react-icons';
import { Flex, Text } from '@radix-ui/themes';

const AdminViewBanner = () => {
  return (
    <Tooltip delayDuration={100}>
      <TooltipTrigger>
        <Flex className="bg-gray-100 rounded-lg px-3 h-8" align="center">
          <InfoCircledIcon className="w-4 h-4 mr-2" />
          <Text className="font-medium text-sm">
            Admin View
          </Text>
        </Flex>
      </TooltipTrigger>
      <TooltipContent side="bottom" className="w-80 text-sm">
        You are viewing this auction as an admin. Admins aren&apos;t allowed to bid or subscribe.
      </TooltipContent>
    </Tooltip>
  );
}

export default AdminViewBanner
